<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">ログ検索条件</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="block-column">
          <div class="column-list">
            <label class="list-input-title">マスタ</label>
            <div class="list-input-content">
              <app-radio-label id="rbtn_goodsMaster" #rbtn_goodsMaster [subid]="'rbtn_goodsMaster'"
                [(ngModel)]="kymw9101Model.radioGroup" name="KYMW9101RBTNGROUP" value="1" label="商品マスタ"
                (change)="rbtnChanged()" [forcedEnabledMode]="'true'" [tabindex]="0"></app-radio-label>
              <app-radio-label id="rbtn_planMaster" #rbtn_planMaster [subid]="'rbtn_planMaster'"
                [(ngModel)]="kymw9101Model.radioGroup" name="KYMW9101RBTNGROUP" value="2" label="企画マスタ"
                (change)="rbtnChanged()" [forcedEnabledMode]="'true'" [tabindex]="0"></app-radio-label>
              <app-radio-label id="rbtn_nonSpec" #rbtn_nonSpec [subid]="'rbtn_nonSpec'"
                [(ngModel)]="kymw9101Model.radioGroup" name="KYMW9101RBTNGROUP" value="3" label="指定しない"
                (change)="rbtnChanged()" [forcedEnabledMode]="'true'" [tabindex]="0"></app-radio-label>
            </div>

            <label class="list-input-title">受注コード</label>
            <div class="list-input-content">
              <app-order-code-text-input id="txti_orderCode" #txti_orderCode [subid]="'txti_orderCode'"
                [(ngModel)]="kymw9101Model.orderCode" [required]="true" [catalogIDField]="txi_DelivCatalogId"
                [disabled]="kymw9101Model.orderCodeDisabled" [forcedEnabledMode]="'true'" [tabindex]="0">
              </app-order-code-text-input>
            </div>

            <label class="list-input-title">配達企画回(翌週)</label>
            <div class="list-input-content">
              <input type="text" class="deliv-catalog" id="txi_DelivCatalogId" #txi_DelivCatalogId readonly="true"/>
            </div>

            <label class="list-input-title">会員生協</label>
            <div class="list-input-content">
              <app-checkbox-label label="い" id="chk_i" #chk_i [(ngModel)]="kymw9101Model.ibaraki"
                [forcedEnabledMode]="'true'" [tabindex]="0"></app-checkbox-label>
              <app-checkbox-label label="と" id="chk_to" #chk_to [(ngModel)]="kymw9101Model.tochigi"
                [forcedEnabledMode]="'true'" [tabindex]="0"></app-checkbox-label>
              <app-checkbox-label label="ぐ" id="chk_gu" #chk_gu [(ngModel)]="kymw9101Model.gunma"
                [forcedEnabledMode]="'true'" [tabindex]="0"></app-checkbox-label>
              <app-checkbox-label label="ち" id="chk_chi" #chk_chi [(ngModel)]="kymw9101Model.chiba"
                [forcedEnabledMode]="'true'" [tabindex]="0"></app-checkbox-label>
              <app-checkbox-label label="さ" id="chk_sa" #chk_sa [(ngModel)]="kymw9101Model.saitama"
                [forcedEnabledMode]="'true'" [tabindex]="0"></app-checkbox-label>
              <app-checkbox-label label="とう" id="chk_tou" #chk_tou [(ngModel)]="kymw9101Model.tokyo"
                [forcedEnabledMode]="'true'" [tabindex]="0"></app-checkbox-label>
              <app-checkbox-label label="な" id="chk_na" #chk_na [(ngModel)]="kymw9101Model.nagano"
                [forcedEnabledMode]="'true'" [tabindex]="0"></app-checkbox-label>
              <app-checkbox-label label="に" id="chk_ni" #chk_ni [(ngModel)]="kymw9101Model.niigata"
                [forcedEnabledMode]="'true'" [tabindex]="0"></app-checkbox-label>
              <app-checkbox-label label="ク" id="chk_ku" #chk_ku [(ngModel)]="kymw9101Model.kuruco"
                [forcedEnabledMode]="'true'" [tabindex]="0"></app-checkbox-label>
            </div>

            <label class="list-input-title">Ｐコード</label>
            <div class="list-input-content">
              <input type="text" class="pcode" id="txti_pcode" #txti_pcode [(ngModel)]="kymw9101Model.pcode" plessInputTextSub
                [restrict]="'[P0-9]'" [maxlength]="8" forcedEnabledMode="true" [tabindex]="0">
            </div>

            <label class="list-input-title">アイテムコード</label>
            <div class="list-input-content">
              <input type="text" class="item-code" id="txti_itemCode" #txti_itemCode [(ngModel)]="kymw9101Model.itemCode"
                plessInputTextSub [restrict]="'[0-9]'" [maxlength]="7" forcedEnabledMode="true" [tabindex]="0">
            </div>

            <label class="list-input-title">ユーザーＩＤ</label>
            <div class="list-input-content">
              <input type="text" class="userid" id="txti_userID" #txti_userID [(ngModel)]="kymw9101Model.userID" plessInputTextSub
                [restrict]="'[a-zA-Z0-9]'" [maxlength]="8" forcedEnabledMode="true" [tabindex]="0">
            </div>

            <label class="list-input-title">更新日</label>
            <div class="list-input-content">
              <div class="element-column">
                <label><input type="checkbox" id="chk_selectDuration" #chk_selectDuration
                  [(ngModel)]="kymw9101Model.selectDuration" (change)="chkSelectDurationChanged(null)"
                  forcedEnabledMode="true" [tabindex]="0">更新日を検索条件に含める</label>

                <div class="element-row">
                  <wj-input-date id="dtf_updateDateFrom" #dtf_updateDateFrom [isRequired]="false"
                    [(text)]="kymw9101Model.updateDateFrom" format="yyyy/MM/dd" [min]="minDate" [max]="maxDate"
                    [class.text-label-required]="true" forcedEnabledMode="true" [tabindex]="0"></wj-input-date>
                  <label>～</label>
                  <wj-input-date id="dtf_updateDateTo" #dtf_updateDateTo [isRequired]="false"
                    [(text)]="kymw9101Model.updateDateTo" format="yyyy/MM/dd" [min]="minDate" [max]="maxDate"
                    [class.text-label-required]="true" forcedEnabledMode="true" [tabindex]="0">
                  </wj-input-date>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>
  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button class="btn-tartiary" id="btn_clear" (click)="clearBtnClicked(null)" forcedEnabledMode="true"
            [tabindex]="0">条件クリア</button>
          <button class="btn-primary" id="btn_search" (click)="searchBtnClicked(null)" forcedEnabledMode="true"
            [tabindex]="0">検索</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>